<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
export default {
  components: {},
  data() {
    return {
      RefreshLoading: false, //刷新
      Loading: false,      //加载
      Finished: false,      //加载完成
      List: [],
      pagination:{
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },
    };
  },

  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    //刷新列表
    refreshList() {
      this.Finished = false;
      this.pagination.index = 0;
      this.loadList().then(res=>{
        this.RefreshLoading = false;
      })
    },
    //加载列表
    loadList() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index + 1,
          size: this.pagination.size,
        }
      };
      var _this = this;
      return new Promise((resolve,reject)=>{
        _this.$api.kbPage(params).then(res=>{
          var data = res.data;
          var list = data.data || [];
          list.map(r=>{
            if(r.imgs){
              r.imgs = JSON.parse(r.imgs);
            }else{
              r.imgs = [];
            }
            return r;
          })
          if(this.pagination.index===1){
            _this.List = list;
          }else{
            _this.List = _this.List.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.List.length >= _this.pagination.total) {
            _this.Finished = true;
          }
          // 加载状态结束
          _this.Loading = false;
          resolve();
        });
      })
      
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/question/index.vue